import CreateVendorCertificationContainer from "./CreateVendorCertificationContainer";
export default CreateVendorCertificationContainer;
